export default __webpack_public_path__ + "c2670397fe07e3833f7339490ce827af.png";